//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('curalate').service('WindowTitleService', [
    '$window',
    function ($window) {
      const self = this;
      const appName = 'Bazaarvoice Vibe | ';

      self.setWindowTitle = function (title) {
        $window.document.title = appName + title;
      };
    },
  ]);
})();
